const translations: Record<string, string> = {
  // Nav
  'nav.home': '홈',
  'nav.about': '소개',
  'nav.services': '서비스',
  'nav.partners': '파트너',
  'nav.tradeData': '무역 데이터',
  'nav.gallery': '갤러리',
  'nav.getInTouch': '문의하기',

  // Hero
  'hero.eyebrow': '브랜드 수출입 컨설팅, 유통, 마케팅',
  'hero.headline1': '한국 · 베트남',
  'hero.headline2': '브랜드게이트웨이\u00a0',
  'hero.headline3': '모나루',
  'hero.desc': '한국과 베트남 현지 네트워크를 직접 가동하여 까다로운 인증 취득은 물론, 메이저 채널 입점을 즉각 실행합니다. 양국 브랜드 진출의 시행착오를 최소화하고 확실한 결과만을 약속드립니다.',
  'hero.cta1': '서비스 보기',
  'hero.cta2': '문의하기',
  'hero.scroll': '스크롤',
  'hero.stat.tradeVolume': '무역 규모',
  'hero.stat.activePartners': '활성 파트너',
  'hero.stat.yearsExp': '년 경력',
  'hero.stat.nationsServed': '진출 국가',

  // About Preview - updated
  'about.eyebrow': '회사 소개',
  'about.established': 'Since 2026',
  'about.heading1': '브랜드 글로벌 확장 파트너',
  'about.heading2': '우리가 만듭니다',
  'about.desc1': '낯선 시장에 대한 불안은 확신으로 바뀝니다. 모나루는 한국과 베트남 현지 네트워크를 직접 가동하여, 브랜드의 첫 씨앗(Seeding)부터 열매(Distribution)까지 전 과정을 책임지는 토털 솔루션 파트너입니다. 현지의 생생한 시장 감각과 전문적인 인증 프로세스를 바탕으로, 귀사의 비즈니스를 가장 안전하고 빠르게 현지 중심부로 안내합니다.',
  'about.pillar1.title': '인증·통관 전담',
  'about.pillar1.desc': '식약처, CR 등 양국의 복잡한 인증을 원스톱으로 처리합니다.',
  'about.pillar2.title': '유통 채널 입점',
  'about.pillar2.desc': '대형마트, 편의점, 온라인 플랫폼 등 메이저 채널에 직접 연결합니다.',
  'about.pillar3.title': '브랜드 현지화',
  'about.pillar3.desc': '양국 소비자 트렌드에 맞춘 마케팅 전략으로 브랜드를 정착시킵니다.',
  'about.stat1.value': '14+',
  'about.stat1.label': '년 전문 경력',
  'about.stat2.value': '120+',
  'about.stat2.label': '활성 파트너사',
  'about.stat3.value': '2개국',
  'about.stat3.label': '직영 네트워크',
  'about.bridge': '직영 연결',
  'about.learnStory': '회사 더 알아보기',

  // Services Preview
  'services.eyebrow': '서비스',
  'services.heading1': '종합적인 무역',
  'services.heading2': '솔루션 및 서비스',
  'services.viewAll': '전체 서비스 보기',
  'services.explore': '서비스 탐색',

  // Trade Data
  'tradeData.eyebrow': '실시간 인사이트',
  'tradeData.heading1': '무역 흐름',
  'tradeData.heading2': '분석',
  'tradeData.desc1': '포괄적인 데이터 플랫폼으로 한국과 베트남 간의 양자 무역 흐름을 추적하세요. 실시간 지표, 트렌드 분석, 섹터 분류를 통해 정보에 입각한 결정을 내리세요.',
  'tradeData.desc2': 'KITA, VCCI 및 양국 세관 당국의 데이터로 매월 업데이트됩니다.',
  'tradeData.viewDashboard': '전체 대시보드 보기',
  'tradeData.vsPriorYear': '전년 대비',

  // Partners
  'partners.trustedBy': '함께하는 기업',
  'partners.heading': '파트너',
  'partners.sub': '브랜드의 성공을 만들어 갑니다.',
  'partners.viewAll': '전체 파트너 보기',

  // CTA
  'cta.eyebrow': '시작할 준비가 되셨나요?',
  'cta.heading': '한국-베트남 무역의 관문',
  'cta.desc': '무역 전문가와 연결하여 모나루는 아시아에서 가장 빠르게 성장하는 무역 통로를 통해 귀사의 비즈니스를 어떻게 가속화할 수 있는지 알아보세요.',
  'cta.primary': '문의하기',
  'cta.secondary': '서비스 보기',

  // Footer
  'footer.tagline': '브랜드의 진심을 해외 소비자의 일상으로',
  'footer.services': '서비스',
  'footer.company': '회사',
  'footer.copyright': '© 2025 MONARU. 모든 권리 보유.',
  'footer.privacy': '개인정보처리방침',
  'footer.terms': '이용약관',
  'footer.cookies': '쿠키 정책',
  'footer.svc1': '인증·통관 전담',
  'footer.svc2': '유통 채널 입점',
  'footer.svc3': '브랜드 현지화',
  'footer.svc4': '시장 진입 컨설팅',
  'footer.svc5': '브랜드 소싱·발굴',
  'footer.svc6': '물류·배송 관리',
  'footer.aboutUs': '회사 소개',
  'footer.ourPartners': '파트너사',
  'footer.gallery': '갤러리',
  'footer.tradeData': '무역 데이터',
  'footer.contactUs': '문의하기',
  'footer.ftaGuide': '한-베 FTA 가이드',
  'footer.tradeStats': '무역 통계',
  'footer.shippingSchedules': '선박 스케줄',
  'footer.regulatoryUpdates': '규정 업데이트',

  // About Page
  'aboutPage.eyebrow': '회사 소개',
  'aboutPage.heading2': '모나루(MONARU)',
  'aboutPage.heroDesc': '모두의 나루터. 아시아에서 가장 역동적인 두 경제를 연결하는 허브',
  'aboutPage.story.eyebrow': '우리 이야기',
  'aboutPage.story.heading': '서울에서 사이공까지 — 무역의 10년',
  'aboutPage.story.p1': '2010년, 한국과 베트남의 무역 전문가들로 구성된 소규모 팀이 핵심적인 문제를 인식했습니다: 한국-베트남 무역의 엄청난 잠재력에도 불구하고, 양국의 기업들에는 두 시장을 진정으로 이해하는 신뢰할 수 있는 이중 언어 파트너가 없었습니다.',
  'aboutPage.story.p2': 'KV 무역 연합은 그 통찰에서 탄생했습니다. 서울 사무소에서 12명의 전문가로 시작하여, 화물 하나하나, 거래 하나하나, 파트너십 하나하나를 통해 명성을 쌓았습니다.',
  'aboutPage.story.p3': '오늘날, 양국 수도에 걸쳐 85명 이상의 전문가를 보유하며, 연간 42억 달러 이상의 무역을 촉진하고 Fortune 500 기업과 역동적인 중소기업을 함께 지원하는 지역에서 가장 신뢰받는 양자 무역 기관으로 성장했습니다.',
  'aboutPage.story.cta': '문의하기',
  'aboutPage.values.eyebrow': '우리의 기반',
  'aboutPage.values.heading': '미션 & 가치',
  'aboutPage.values.sub': '모든 결정의 원동력',
  'aboutPage.milestones.eyebrow': '우리의 여정',
  'aboutPage.milestones.heading': '주요 이정표',
  'aboutPage.value.partnership.title': '파트너십 최우선',
  'aboutPage.value.partnership.desc': '우리는 단순한 거래가 아닌 지속적인 관계를 구축합니다. 귀사의 성장이 우리의 성공입니다.',
  'aboutPage.value.integrity.title': '항상 정직',
  'aboutPage.value.integrity.desc': '우리가 서비스하는 모든 시장에서 투명한 거래, 정직한 조언, 윤리적 관행을 실천합니다.',
  'aboutPage.value.innovation.title': '혁신 주도',
  'aboutPage.value.innovation.desc': '기술과 데이터를 활용하여 더 스마트하고, 더 빠르고, 더 효율적인 무역 솔루션을 제공합니다.',
  'aboutPage.value.local.title': '현지 전문성',
  'aboutPage.value.local.desc': '한국과 베트남 모두에 대한 깊은 문화 및 규제 지식 — 귀사의 경쟁 우위.',
  'aboutPage.ms.2010.title': '서울에서 설립',
  'aboutPage.ms.2010.desc': '한국-베트남 양자 무역에 집중하는 12명의 무역 전문가 팀으로 KV 무역 연합 설립.',
  'aboutPage.ms.2013.title': '호치민시 사무소',
  'aboutPage.ms.2013.desc': '첫 번째 베트남 사무소를 개설하여 HCMC에 영구적으로 주재하는 최초의 한국 무역 기관이 됨.',
  'aboutPage.ms.2016.title': '10억 달러 무역 이정표',
  'aboutPage.ms.2016.desc': '양국 전역의 200개 이상의 기업 고객을 대상으로 양자 무역 10억 달러를 돌파.',
  'aboutPage.ms.2019.title': 'FTA 전문 인증',
  'aboutPage.ms.2019.desc': '공식 인정받은 한국-베트남 FTA 전문 기업이 되어 고객의 90%에게 특혜 관세 절감 달성.',
  'aboutPage.ms.2022.title': '디지털 무역 플랫폼',
  'aboutPage.ms.2022.desc': '자체 무역 분석 및 화물 추적 플랫폼 출시로 고객의 국경 간 물류 관리 방식 혁신.',
  'aboutPage.ms.2024.title': '42억 달러 기록의 해',
  'aboutPage.ms.2024.desc': '24개국에 걸쳐 1,240개 이상의 활성 기업 파트너와 함께 42억 달러의 무역 규모 기록 달성.',

  // Services Page
  'servicesPage.eyebrow': '모나루 서비스',
  'servicesPage.heading1': '브랜드 진출 패키지',
  'servicesPage.heading2': '모든 것을 함께',
  'servicesPage.heroDesc': '인증부터 유통, 브랜드 현지화까지 한국·베트남 시장 진출의 시행착오를 줄이고 확실한 결과에만 집중하세요. 모나루가 전 과정을 함께합니다.',
  'servicesPage.cta.heading': '브랜드 진출을 시작할 준비가 되셨나요?',
  'servicesPage.cta.desc': '지금 전문가와 무료 상담을 시작하고, 귀사 브랜드에 맞는 맞춤 진출 전략을 받아보세요.',
  'servicesPage.cta.btn': '문의하기',
  'servicesPage.enquireNow': '지금 문의',

  // Contact Page
  'contactPage.eyebrow': '문의하기',
  'contactPage.heading1': '무엇을 도와드릴까요?',
  'contactPage.heading2': '시작하세요',
  'contactPage.heroDesc': '전문가팀이 도움을 드릴 준비가 되어 있습니다. 아래 메시지 보내기를 통해 연락 주세요.',
  'contactPage.offices.heading': '사무소',
  'contactPage.offices.seoul': '한국',
  'contactPage.offices.hcmc': '베트남',
  'contactPage.offices.hours': '영업 시간',
  'contactPage.offices.hoursMF': '월요일 – 금요일: 09:00 – 18:00 KST',
  'contactPage.offices.hoursSat': '토요일: 09:00 – 13:00 KST',
  'contactPage.offices.hoursNote': '활성 화물에 대한 긴급 라인은 24/7 운영',
  'contactPage.form.heading': '메시지 보내기',
  'contactPage.form.sub': '양식을 작성하시면 영업일 기준 하루 내에 전문가가 답변해 드립니다.',
  'contactPage.form.name': '성명',
  'contactPage.form.email': '이메일 주소',
  'contactPage.form.company': '회사',
  'contactPage.form.service': '관심 서비스',
  'contactPage.form.serviceSelect': '서비스 선택',
  'contactPage.form.message': '메시지',
  'contactPage.form.messagePlaceholder': '무역 요구사항을 알려주세요...',
  'contactPage.form.submit': '메시지 보내기',
  'contactPage.form.submitting': '전송 중...',
  'contactPage.form.successTitle': '메시지 수신됨',
  'contactPage.form.successDesc': '연락해 주셔서 감사합니다. 팀이 영업일 기준 하루 내에 연락드리겠습니다.',
  'contactPage.form.error': '문제가 발생했습니다. 다시 시도하거나 이메일로 직접 문의해 주세요.',

  // Import Brands
  'importBrands.eyebrow': '수입 브랜드',
  'importBrands.heading1': '베트남 프리미엄 브랜드',
  'importBrands.heading2': '한국 공식 수입·유통',
  'importBrands.subDesc': '모나루가 직접 발굴하고 한국 시장에 소개하는 베트남 대표 브랜드',
  'importBrands.badge': '공식 수입 파트너',
  'importBrands.established': '설립 연도',
  'importBrands.aboutBrand': '브랜드 소개',
  'importBrands.officialPartner': 'MONARU 공식 한국 수입·유통',
  'importBrands.officialPartnerDesc': '모나루를 통해 한국 전국 유통망 입점 및 B2B 공급',
  'importBrands.productLine': '주요 제품 라인',
  'importBrands.ctaInquiry': '수입 문의하기',
  'importBrands.ctaCatalog': '카탈로그 요청',
  'importBrands.stat.origin': '생산지',
  'importBrands.stat.exportCountries': '수출 국가',
  'importBrands.stat.heritage': '브랜드 역사',
  'importBrands.stat.marketShare': '베트남 인스턴트 커피',

  // Brands Preview (replaces services section on home)
  'brands.eyebrow': '수입 · 수출 브랜드',
  'brands.heading1': '모나루 협력 브랜드',
  'brands.heading2': '취급 브랜드',
  'brands.inquiry': '브랜드 문의하기',
  'brands.import': '수입 브랜드',
  'brands.export': '수출 브랜드',
  'brands.inquireNow': '문의하기',

  // Partners Page
  'partnersPage.eyebrow': '네트워크',
  'partnersPage.heading1': '전략적 파트너',
  'partnersPage.heading2': '양국을 잇다',
  'partnersPage.heroDesc': '정부 기관, 대기업, 중소기업에 이르기까지 한국과 베트남을 아우르는 신뢰 네트워크가 귀사의 연결을 기다립니다.',
  'partnersPage.section.eyebrow': '브랜드 게이트웨이',
  'partnersPage.section.heading': '모나루 협력사',
  'partnersPage.section.sub': '양국에서 함께 성공을 만들어 갑니다',
  'partnersPage.kr.label': '한국 파트너사',
  'partnersPage.vn.label': '베트남 파트너사',
  'partnersPage.cta.eyebrow': '프로그램 참여',
  'partnersPage.cta.heading': '브랜드를 함께 성장시킵니다.',
  'partnersPage.cta.desc': '1,240개 이상의 기업이 한국-베트남 무역 통로를 활용하고 있습니다. 해외 지사 없이 브랜드 진출을 시작하세요.',
  'partnersPage.cta.btn': '문의하기',

  // Gallery Page
  'galleryPage.eyebrow': '비주얼 스토리',
  'galleryPage.heading1': '갤러리',
  'galleryPage.heading2': '한국 · 베트남',
  'galleryPage.heroDesc': '항구, 파트너십, 무역 사절단, 한국-베트남 교역로를 정의하는 랜드마크를 담은 시각 여정입니다.',
  'galleryPage.filter.all': '전체',
  'galleryPage.filter.korea': '한국',
  'galleryPage.filter.vietnam': '베트남',
  'galleryPage.filter.events': '행사',
  'galleryPage.allPhotos': '전체 사진',

  // Contact Form Service Options
  'contactPage.form.service.koreanExport': '한국 브랜드 수출 문의',
  'contactPage.form.service.vietnamDist': '베트남 브랜드 유통 문의',

  // Trade Data Page
  'tradeDataPage.eyebrow': '애널리틱스 허브',
  'tradeDataPage.heading1': '무역 흐름',
  'tradeDataPage.heading2': '애널리틱스 대시보드',
  'tradeDataPage.desc': '한국과 베트남 양자 무역의 실시간 지표, 섹터 분석, 트렌드 예측. KITA, VCCI 및 세관 당국 데이터 기반.',
  'tradeDataPage.monthly.title': '월별 무역 규모 (백만 달러)',
  'tradeDataPage.monthly.sub': '한국 & 베트남 양자 수출 — FY2024',
  'tradeDataPage.category.title': '카테고리별 무역 (%)',
  'tradeDataPage.category.sub': '양자 무역 섹터 분포',
  'tradeDataPage.distribution.title': '무역 분포',
  'tradeDataPage.distribution.sub': '전체 섹터별 구성',
  'tradeDataPage.stat.totalVolume': '총 무역 규모',
  'tradeDataPage.stat.activeCompanies': '활성 기업',
  'tradeDataPage.stat.shipments': '처리된 화물',
  'tradeDataPage.stat.nations': '파트너 국가',
  'tradeDataPage.korea.exports': '한국 수출',
  'tradeDataPage.vietnam.exports': '베트남 수출',
  'tradeDataPage.korea.label': '한국',
  'tradeDataPage.vietnam.label': '베트남',
  'tradeDataPage.yoy': 'YoY',

  // Page Titles
  'page.title.home': 'MONARU | 한국·베트남 브랜드 게이트웨이',
  'page.title.about': 'MONARU | 소개',
  'page.title.services': 'MONARU | 서비스',
  'page.title.partners': 'MONARU | 파트너',
  'page.title.tradeData': 'MONARU | 무역 데이터',
  'page.title.gallery': 'MONARU | 갤러리',
  'page.title.contact': 'MONARU | 문의하기',
  'page.title.news': 'MONARU | 소식',

  // Nav - News
  'nav.news': '소식',

  // News Page
  'newsPage.eyebrow': '최신 소식',
  'newsPage.heading1': 'MONARU',
  'newsPage.heading2': '뉴스 & 인사이트',
  'newsPage.heroDesc': '한국·베트남 무역 시장의 최신 소식, 업계 인사이트, 그리고 MONARU의 다양한 활동을 전해드립니다.',
  'newsPage.all': '전체',
  'newsPage.readMore': '자세히 보기',
  'newsPage.empty': '등록된 소식이 없습니다.',
  'newsPage.backToList': '목록으로 돌아가기',
  'newsPage.publishedAt': '게시일',
  'newsPage.by': '작성자',
  'newsPage.share': '공유하기',
  'newsPage.notFound': '포스팅을 찾을 수 없습니다.',
};

export default translations;
